// based on rc-time-picker 3.3.1
export { default } from './TimePicker'



// WEBPACK FOOTER //
// ./components/vc-time-picker/index.js